import React, { useState, useEffect } from "react";
import { array, string, func, number } from "prop-types";
import { SectionHeading } from "../../atoms/SectionHeading";
import { Pagination } from "../../atoms/Pagination";
import { SpeakerCard } from "../SpeakerCard";
import "./participants-list-section.m.css";

export const ParticipantsListSection = ({ title = "Participants", participants = [], allParticipants = [], currentPage = 1, itemsPerPage = 20, onPageChange, onBack }) => {
  const [groupedParticipants, setGroupedParticipants] = useState([]);

  const totalParticipants = allParticipants.length;
  const totalPages = totalParticipants > 0 ? Math.ceil(totalParticipants / itemsPerPage) : 0;
  const startIndex = (currentPage - 1) * itemsPerPage;

  // Function to group participants based on screen size
  const groupParticipantsResponsively = (participantList) => {
    if (!participantList || participantList.length === 0) return [];

    let itemsPerRow = 4;

    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width >= 768 && width <= 1023) {
        itemsPerRow = 3;
      } else if (width < 768) {
        itemsPerRow = 1;
      }
    }

    const groups = [];
    for (let i = 0; i < participantList.length; i += itemsPerRow) {
      groups.push(participantList.slice(i, i + itemsPerRow));
    }

    return groups;
  };

  useEffect(() => {
    const updateGrouping = () => {
      setGroupedParticipants(groupParticipantsResponsively(participants));
    };

    updateGrouping();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateGrouping);
      return () => window.removeEventListener('resize', updateGrouping);
    }
  }, [participants]);

  const handlePageChange = (page) => {
    // Scroll to section heading
    const sectionHeader = document.getElementById('participants-section-header');
    if (sectionHeader) {
      sectionHeader.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    // Then trigger the page change
    if (onPageChange) {
      onPageChange(page);
    }
  };

  return (
    <div id="participants-list-section" styleName="participants-list-section">
      <div id="participants-section-header" styleName="section-header">
        <SectionHeading>{`${totalParticipants} ${title}`}</SectionHeading>
      </div>
      <div styleName="participant-profiles">
        {groupedParticipants.map((row, rowIndex) => (
          <div key={`row-${rowIndex}`} styleName="participants-row">
            {row.map(({ name = "", designation = "", company = "", imageUrl = "", linkedIn = "" }, index) => (
              <SpeakerCard
                key={`participant-${name || index}-${startIndex + rowIndex * row.length + index}`}
                name={name}
                designation={designation}
                company={company}
                imageUrl={imageUrl}
                isConfirmed={false}
                linkedIn={linkedIn}
                disableBioPopup={true}
                type="participant"
              />
            ))}
          </div>
        ))}
      </div>
      <div styleName="pagination-container">
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

ParticipantsListSection.propTypes = {
  title: string.isRequired,
  participants: array,
  allParticipants: array,
  currentPage: number,
  itemsPerPage: number,
  onPageChange: func,
  onBack: func,
};
